import { OfferModelDetail } from '../types/offers';

type UrlDirectoryType = {
  [key: string]: {
    identifier: string;
    carlineId: string;
    carlineName: string;
    url: string;
    modelFamily: string;
    bodyType: string;
    modelCodeDescription: string;
  };
};

const buildUrlDirectory: UrlDirectoryType = {
  'e-tron GT': {
    identifier: 'etrongt',
    carlineId: 'setrongt-2025-F8',
    carlineName: '2025 Audi S e-tron® GT',
    url: 'https://www.audiusa.com/us/web/en/models/e-tron-gt/s-e-tron-gt/2025/overview/build.html',
    modelFamily: 'e-tron GT',
    bodyType: 'Sedan',
    modelCodeDescription: '2025 S e-tron GT quattro',
  },
  'RS e-tron GT': {
    identifier: 'etrongt',
    carlineId: 'rsetrongtperformance-2025-F8',
    carlineName: '2025 Audi RS e-tron® GT',
    url: 'https://www.audiusa.com/us/web/en/models/e-tron-gt/rs-e-tron-gt/2025/overview/build.html',
    modelFamily: 'RS e-tron GT',
    bodyType: 'Sedan',
    modelCodeDescription: '2024 RS e-tron GT quattro',
  },
  'Q4 e-tron,base': {
    identifier: 'q4',
    carlineId: 'q4sbetron-2025-F4',
    carlineName: '2025 Audi Q4 Sportback e-tron®',
    url: 'https://www.audiusa.com/us/web/en/models/q4/q4-e-tron/2025/overview/build.html',
    modelFamily: 'Q4 e-tron',
    bodyType: 'SUV',
    modelCodeDescription: '2024 Q4 Sportback e-tron quattro',
  },
  'Q4 e-tron,Sportback': {
    identifier: 'q4',
    carlineId: 'q4sbetron-2025-F4',
    carlineName: '2025 Audi Q4 Sportback e-tron®',
    url: 'https://www.audiusa.com/us/web/en/models/q4/q4-sportback-e-tron/2025/overview/build.html',
    modelFamily: 'Q4 e-tron',
    bodyType: 'SUV',
    modelCodeDescription: '2024 Q4 Sportback e-tron quattro',
  },
  'Q6 e-tron': {
    identifier: 'q6',
    carlineId: 'q6etron-2025-GF',
    carlineName: '2025 Audi Q6 e-tron®',
    url: 'https://www.audiusa.com/us/web/en/models/q6-e-tron/q6-e-tron/2025/overview/build.html',
    modelFamily: 'Q6 e-tron',
    bodyType: 'SUV',
    modelCodeDescription: '2025 Q6 e-tron 50 RWD',
  },
  'SQ6 e-tron': {
    identifier: 'q6',
    carlineId: 'sq6etron-2025-GF',
    carlineName: '2025 Audi SQ6 e-tron®',
    url: 'https://www.audiusa.com/us/web/en/models/q6-e-tron/sq6-e-tron/2025/overview/build.html',
    modelFamily: 'SQ6 e-tron',
    bodyType: 'SUV',
    modelCodeDescription: '2025 SQ6 e-tron quattro',
  },
  'Q8 e-tron,base': {
    identifier: 'q8etron',
    carlineId: 'q8etron-2024-GE',
    carlineName: '2024 Audi Q8 e-tron®',
    url: 'https://www.audiusa.com/us/web/en/models/q8-e-tron/q8-e-tron/2024/overview/build.html',
    modelFamily: 'Q8 e-tron',
    bodyType: 'SUV',
    modelCodeDescription: '2024 Q8 e-tron 55 quattro',
  },
  'Q8 e-tron,Sportback': {
    identifier: 'q8etron',
    carlineId: 'q8sbetron-2024-GE',
    carlineName: '2024 Audi Q8 Sportback e-tron®',
    url: 'https://www.audiusa.com/us/web/en/models/q8-e-tron/q8-sportback-e-tron/2024/overview/build.html',
    modelFamily: 'Q8 e-tron',
    bodyType: 'SUV',
    modelCodeDescription: '2024 Q8 Sportback e-tron 55 quattro',
  },
  'SQ8 e-tron,base': {
    identifier: 'q8etron',
    carlineId: 'sq8etron-2024-GE',
    carlineName: '2024 Audi SQ8 e-tron®',
    url: 'https://www.audiusa.com/content/us/web/en/models/q8-e-tron/sq8-e-tron/2024/overview/build.html',
    modelFamily: 'SQ8 e-tron',
    bodyType: 'SUV',
    modelCodeDescription: '2025 SQ8 e-tron quattro',
  },
  'SQ8 e-tron,Sportback': {
    identifier: 'q8etron',
    carlineId: 'sq8sbetron-2024-GE',
    carlineName: '2024 Audi SQ8 Sportback e-tron®',
    url: 'https://www.audiusa.com/us/web/en/models/q8-e-tron/sq8-sportback-e-tron/2024/overview/build.html',
    modelFamily: 'SQ8 e-tron',
    bodyType: 'SUV',
    modelCodeDescription: '2024 SQ8 Sportback e-tron quattro',
  },
  Q3: {
    identifier: 'q3',
    carlineId: 'q3-2025-F3',
    carlineName: '2025 Audi Q3',
    url: 'https://www.audiusa.com/us/web/en/models/q3/q3/2025/overview/build.html',
    modelFamily: 'Q3',
    bodyType: 'SUV',
    modelCodeDescription: '2024 Q3 S line 45 TFSI quattro',
  },
  'Q5,base': {
    identifier: 'q5',
    carlineId: 'q5-2025-FY',
    carlineName: '2025 Audi Q5',
    url: 'https://www.audiusa.com/content/us/web/en/models/q5/q5/2025/overview/build.html',
    modelFamily: 'Q5',
    bodyType: 'SUV',
    modelCodeDescription: '2024 Q5 40 TFSI quattro',
  },
  'Q5,Sportback': {
    identifier: 'q5',
    carlineId: 'q5sb-2025-FY',
    carlineName: '2025 Audi Q5 Sportback',
    url: 'https://www.audiusa.com/content/us/web/en/models/q5/q5-sportback/2025/overview/build.html',
    modelFamily: 'Q5',
    bodyType: 'SUV',
    modelCodeDescription: '2024 Q5 Sportback 45 TFSI quattro',
  },
  // Q5 Plug-in Hybrid
  'Q5,Plug': {
    identifier: 'q5',
    carlineId: 'q5tfsie-2025-FY',
    carlineName: '2025 Audi Q5 Plug-in Hybrid',
    url: 'https://www.audiusa.com/content/us/web/en/models/q5/q5-phev/2025/overview/build.html',
    modelFamily: '',
    bodyType: '',
    modelCodeDescription: '',
  },
  'SQ5,base': {
    identifier: 'q5',
    carlineId: 'sq5-2025-FY',
    carlineName: '2025 Audi SQ5',
    url: 'https://www.audiusa.com/us/web/en/models/q5/sq5/2024/overview/build.html',
    modelFamily: 'SQ5',
    bodyType: 'SUV',
    modelCodeDescription: '2025 SQ5 quattro',
  },
  'SQ5,Sportback': {
    identifier: 'q5',
    carlineId: 'sq5sb-2025-FY',
    carlineName: '2025 Audi SQ5 Sportback',
    url: 'https://www.audiusa.com/us/web/en/models/q5/sq5-sportback/2025/overview/build.html',
    modelFamily: 'SQ5',
    bodyType: 'SUV',
    modelCodeDescription: '2024 SQ5 Sportback quattro',
  },
  Q7: {
    identifier: 'q7',
    carlineId: 'q7-2024-4M',
    carlineName: '2025 Audi Q7',
    url: 'https://www.audiusa.com/content/us/web/en/models/q7/q7/2025/overview/build.html',
    modelFamily: 'Q7',
    bodyType: 'SUV',
    modelCodeDescription: '2024 Q7 55 TFSI quattro',
  },
  SQ7: {
    identifier: 'q7',
    carlineId: 'sq7-2024-4M',
    carlineName: '2025 SQ7',
    url: 'https://www.audiusa.com/content/us/web/en/models/q7/sq7/2025/overview/build.html',
    modelFamily: 'SQ7',
    bodyType: 'SUV',
    modelCodeDescription: '2025 SQ7 quattro',
  },
  Q8: {
    identifier: 'q8',
    carlineId: 'q8-2025-4M',
    carlineName: '2025 Audi Q8',
    url: 'https://www.audiusa.com/content/us/web/en/models/q8/q8/2025/overview/build.html',
    modelFamily: 'Q8',
    bodyType: 'SUV',
    modelCodeDescription: '2025 Q8 55 TFSI quattro',
  },
  SQ8: {
    identifier: 'q8',
    carlineId: 'sq8-2025-4M',
    carlineName: '2025 Audi SQ8',
    url: 'https://www.audiusa.com/content/us/web/en/models/q8/sq8/2025/overview/build.html',
    modelFamily: 'SQ8',
    bodyType: 'SUV',
    modelCodeDescription: '2025 SQ8 quattro',
  },
  'RS Q8': {
    identifier: 'q8',
    carlineId: 'rsq8-2025-4M',
    carlineName: '2025 RS Q8 performance',
    url: 'https://www.audiusa.com/content/us/web/en/models/q8/rsq8/2025/overview/build.html',
    modelFamily: 'RS Q8',
    bodyType: 'SUV',
    modelCodeDescription: '2024 RS Q8 quattro',
  },
  A3: {
    identifier: 'a3',
    carlineId: 'a3limo-2025-8Y',
    carlineName: '2025 A3',
    url: 'https://www.audiusa.com/content/us/web/en/models/a3/a3/2025/overview/build.html',
    modelFamily: 'A3',
    bodyType: 'Sedan',
    modelCodeDescription: '2024 A3 Sedan 40 TFSI FWD',
  },
  S3: {
    identifier: 'a3',
    carlineId: 's3limo-2025-8Y',
    carlineName: '2025 S3',
    url: 'https://www.audiusa.com/content/us/web/en/models/a3/s3/2025/overview/build.html',
    modelFamily: 'S3',
    bodyType: 'Sedan',
    modelCodeDescription: '2024 S3 Sedan quattro',
  },
  'RS 3': {
    identifier: 'a3',
    carlineId: 'rs3limo-2024-8Y',
    carlineName: '2024 RS 3',
    url: 'https://www.audiusa.com/us/web/en/models/a3/rs3-sedan/2024/overview/build.html',
    modelFamily: 'RS 3',
    bodyType: 'Sedan',
    modelCodeDescription: '2024 RS 3 Sedan quattro',
  },
  'A4,Sedan': {
    identifier: 'a4',
    carlineId: 'a4limo-2025-8W',
    carlineName: '2025 A4 Sedan',
    url: 'https://www.audiusa.com/content/us/web/en/models/a4/a4-sedan/2025/overview/build.html',
    modelFamily: 'A4',
    bodyType: 'Sedan',
    modelCodeDescription: '2025 A4 Sedan',
  },
  'A4,allroad quattro': {
    identifier: 'a4',
    carlineId: 'a4aq-2025-8W',
    carlineName: '2025 A4 allroad® quattro®',
    url: 'https://www.audiusa.com/content/us/web/en/models/a4/a4-allroad/2025/overview/build.html',
    modelFamily: 'A4',
    bodyType: 'allroad quattro',
    modelCodeDescription: '2025 A4 allroad 45 TFSI quattro',
  },
  S4: {
    identifier: 'a4',
    carlineId: 's4limo-2025-8W',
    carlineName: '2025 S4 Sedan',
    url: 'https://www.audiusa.com/content/us/web/en/models/a4/s4-sedan/2025/overview/build.html',
    modelFamily: 'S4',
    bodyType: 'Sedan',
    modelCodeDescription: '2024 S4 Sedan quattro',
  },
  'A5,Coupe': {
    identifier: 'a5',
    carlineId: 'a5coupe-2024-F5',
    carlineName: '2024 A5 Coupe',
    url: 'https://www.audiusa.com/us/web/en/models/a5/a5-coupe/2024/overview/build.html',
    modelFamily: 'A5',
    bodyType: 'Coupe',
    modelCodeDescription: '2024 A5 Coupe 45 TFSI quattro',
  },
  'S5,Coupe': {
    identifier: 'a5',
    carlineId: 's5coupe-2024-F5',
    carlineName: '2024 S5 Coupe',
    url: 'https://www.audiusa.com/us/web/en/models/a5/s5-coupe/2024/overview/build.html',
    modelFamily: 'S5',
    bodyType: 'Coupe',
    modelCodeDescription: '2024 S5 Coupe quattro',
  },
  'RS 5,Coupe': {
    identifier: 'a5',
    carlineId: 'rs5coupe-2024-F5',
    carlineName: '2024 RS 5 Coupe',
    url: 'https://www.audiusa.com/us/web/en/models/a5/rs5-coupe/2024/overview/build.html',
    modelFamily: 'RS 5',
    bodyType: 'Coupe',
    modelCodeDescription: '2024 RS 5 Coupe quattro',
  },
  'A5,Sportback': {
    identifier: 'a5',
    carlineId: 'a5sb-2025-F5',
    carlineName: '2025 A5 Sportback',
    url: 'https://www.audiusa.com/content/us/web/en/models/a5/a5-sportback/2025/overview/build.html',
    modelFamily: 'A5',
    bodyType: 'Sportback',
    modelCodeDescription: '2025 A5 Sportback 40 TFSI quattro',
  },
  'S5,Sportback': {
    identifier: 'a5',
    carlineId: 's5sb-2025-F5',
    carlineName: '2025 S5 Sportback',
    url: 'https://www.audiusa.com/content/us/web/en/models/a5/s5-sportback/2025/overview/build.html',
    modelFamily: 'S5',
    bodyType: 'Sportback',
    modelCodeDescription: '2025 S5 Sportback quattro',
  },
  'RS 5,Sportback': {
    identifier: 'a5',
    carlineId: 'rs5sb-2025-F5',
    carlineName: '2025 RS 5 Sportback',
    url: 'https://www.audiusa.com/content/us/web/en/models/a5/rs5-sportback/2025/overview/build.html',
    modelFamily: 'RS 5',
    bodyType: 'Sportback',
    modelCodeDescription: '2024 RS 5 Sportback quattro',
  },
  'A5,Cabriolet': {
    identifier: 'a5',
    carlineId: 'a5cabrio-2024-F5',
    carlineName: '2024 A5 Cabriolet',
    url: 'https://www.audiusa.com/us/web/en/models/a5/a5-cabriolet/2024/overview/build.html',
    modelFamily: 'A5',
    bodyType: 'Cabriolet',
    modelCodeDescription: '2024 A5 Cabriolet 45 TFSI quattro',
  },
  'S5,Cabriolet': {
    identifier: 'a5',
    carlineId: 's5cabrio-2024-F5',
    carlineName: '2024 S5 Cabriolet',
    url: 'https://www.audiusa.com/us/web/en/models/a5/s5-cabriolet/2024/overview/build.html',
    modelFamily: 'S5',
    bodyType: 'Cabriolet',
    modelCodeDescription: '2024 S5 Cabriolet quattro',
  },
  'A6,Sedan': {
    identifier: 'a6',
    carlineId: 'a6limo-2025-4A',
    carlineName: '2025 A6 Sedan',
    url: 'https://www.audiusa.com/content/us/web/en/models/a6/a6-sedan/2025/overview/build.html',
    modelFamily: 'A6',
    bodyType: 'Sedan',
    modelCodeDescription: '2025 A6 Sedan 45 TFSI quattro',
  },
  S6: {
    identifier: 'a6',
    carlineId: 's6limo-2025-4A',
    carlineName: '2025 S6 Sedan',
    url: 'https://www.audiusa.com/content/us/web/en/models/a6/s6-sedan/2025/overview/build.html',
    modelFamily: 'S6',
    bodyType: 'Sedan',
    modelCodeDescription: '2025 S6 Sedan quattro',
  },
  'A6,allroad quattro': {
    identifier: 'a6',
    carlineId: 'a6aq-2025-4A',
    carlineName: '2025 A6 allroad® quattro®',
    url: 'https://www.audiusa.com/content/us/web/en/models/a6/a6-allroad/2025/overview/build.html',
    modelFamily: 'A6',
    bodyType: 'allroad quattro',
    modelCodeDescription: '2025 A6 allroad 55 TFSI quattro',
  },
  'RS 6': {
    identifier: 'a6',
    carlineId: 'rs6avantperformance-2025-4A',
    carlineName: '2025 RS 6 Avant performance',
    url: 'https://www.audiusa.com/content/us/web/en/models/a6/rs6-avant/2025/overview/build.html',
    modelFamily: 'RS 6',
    bodyType: 'Avant',
    modelCodeDescription: '2024 RS 6 Avant Performance quattro',
  },
  A7: {
    identifier: 'a7',
    carlineId: 'a7sb-2025-4K',
    carlineName: '2025 Audi A7',
    url: 'https://www.audiusa.com/content/us/web/en/models/a7/a7-sportback/2025/overview/build.html',
    modelFamily: 'A7',
    bodyType: 'Sportback',
    modelCodeDescription: '2024 A7 55 TFSI quattro',
  },
  S7: {
    identifier: 'a7',
    carlineId: 's7sb-2025-4K',
    carlineName: '2025 Audi S7',
    url: 'https://www.audiusa.com/content/us/web/en/models/a7/s7-sportback/2025/overview/build.html',
    modelFamily: 'S7',
    bodyType: 'Sportback',
    modelCodeDescription: '2025 S7 quattro',
  },
  'RS 7': {
    identifier: 'a7',
    carlineId: 'rs7sb-2025-4K',
    carlineName: '2025 Audi RS 7 performance',
    url: 'https://www.audiusa.com/us/web/en/models/a7/rs7/2024/overview/build.html',
    modelFamily: 'RS 7',
    bodyType: 'Sportback',
    modelCodeDescription: '2024 RS 7 Performance quattro',
  },
  A8: {
    identifier: 'a8',
    carlineId: 'a8l-2025-4N',
    carlineName: '2025 A8',
    url: 'https://www.audiusa.com/content/us/web/en/models/a8/a8-sedan/2025/overview/build.html',
    modelFamily: 'A8',
    bodyType: 'Sedan',
    modelCodeDescription: '2025 A8 55 TFSI quattro',
  },
  S8: {
    identifier: 'a8',
    carlineId: 's8l-2025-4N',
    carlineName: '2025 S8',
    url: 'https://www.audiusa.com/us/web/en/models/a8/s8-sedan/2025/overview/build.html',
    modelFamily: 'S8',
    bodyType: 'Sedan',
    modelCodeDescription: '2025 S8 quattro',
  },
};

export const getConfiguratorUrl = (offerDetails?: OfferModelDetail) => {
  if (!offerDetails) return null;
  const { bodyType, modelFamily, modelCodeDescription } = offerDetails;
  // For those model families that do not have multiple body types
  if (Object.prototype.hasOwnProperty.call(buildUrlDirectory, modelFamily)) {
    return buildUrlDirectory[modelFamily]?.url ?? null;
  }
  const combined = `${modelFamily},${bodyType}`;
  // For those model families that have multiple body types
  if (Object.prototype.hasOwnProperty.call(buildUrlDirectory, combined)) {
    return buildUrlDirectory[combined]?.url ?? null;
  }
  // Edge Cases
  if (modelFamily === 'Q4 e-tron') {
    if (modelCodeDescription?.includes('Sportback')) {
      return buildUrlDirectory['Q4 e-tron,Sportback']?.url ?? null;
    }
    return buildUrlDirectory['Q4 e-tron,base']?.url ?? null;
  }
  if (modelFamily === 'Q8 e-tron') {
    if (modelCodeDescription?.includes('Sportback')) {
      return buildUrlDirectory['Q8 e-tron,Sportback'].url;
    }
    return buildUrlDirectory['Q8 e-tron,base']?.url ?? null;
  }
  if (modelFamily === 'SQ8 e-tron') {
    if (modelCodeDescription?.includes('Sportback')) {
      return buildUrlDirectory['SQ8 e-tron,Sportback'].url;
    }
    return buildUrlDirectory['SQ8 e-tron,base']?.url ?? null;
  }
  if (modelFamily === 'Q5') {
    if (modelCodeDescription?.includes('Sportback')) {
      return buildUrlDirectory['Q5,Sportback'].url;
    }
    if (modelCodeDescription?.includes('TFSI e')) {
      return buildUrlDirectory['Q5,Plug'].url;
    }
    return buildUrlDirectory['Q5,base']?.url ?? null;
  }
  if (modelFamily === 'SQ5') {
    if (modelCodeDescription?.includes('Sportback')) {
      return buildUrlDirectory['SQ5,Sportback'].url;
    }
    return buildUrlDirectory['SQ5,base']?.url ?? null;
  }
  return null; // Explicitly return null if the key doesn't exist
};
